<template>
  <v-bottom-sheet v-model="isActive" persistent>
    <div class="modal-container">
      <v-form ref="form" v-model="isFormValid">
        <v-text-field
          v-model="form.number"
          class="mt-6"
          label="NÚMERO DE R.S."
          type="number"
          :rules="[(v) => !!v || 'Type is required']"
          outlined
          hide-details
        ></v-text-field>
        <v-btn
          @click="selectType(orderType)"
          v-for="orderType in orderTypes"
          :key="orderType.id"
          :color="form.type.id === orderType.id ? 'primary' : ''"
          :outlined="form.type.id === orderType.id ? false : true"
          depressed
          class="mt-3"
          large
          style="width: -webkit-fill-available"
        >
          {{ orderType.description }}
        </v-btn>

        <div class="d-flex justify-space-between mt-7">
          <div class="button-container">
            <v-btn @click="close()" outlined large color="red" style="width: -webkit-fill-available"> Cancelar </v-btn>
          </div>
          <div class="button-container">
            <v-btn color="primary" large depressed @click="handleSave" style="width: -webkit-fill-available" :disabled="!isFormValid"> Salvar </v-btn>
          </div>
        </div>
      </v-form>
    </div>

    <v-snackbar v-model="isSnackbarActive" :timeout="2000" :top="true">
      Ocorreu um erro ao salvar
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="isSnackbarActive = false"> Fechar </v-btn>
      </template>
    </v-snackbar>

    <v-overlay :value="isLoading" absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-bottom-sheet>
</template>

<script>
import ServiceOrderService from '@/services/api/serviceOrder';
import { mapActions } from 'vuex';

export default {
  name: 'ModalEditServiceOrder',
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    serviceOrder: {
      type: Object,
      required: true
    },
    orderTypes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      isSnackbarActive: false,
      isFormValid: false,
      form: {
        number: 0,
        type: {}
      }
    };
  },
  methods: {
    ...mapActions('ServiceOrder', ['updateServiceOrderDetails']),
    close() {
      this.form.value = {
        number: 0,
        type: {}
      };

      this.$emit('close');
    },
    selectType(type) {
      this.form.type = type;
    },
    async handleSave() {
      if (!this.serviceOrder.id) return;

      try {
        this.isLoading = true;
        const dataToSent = {
          number: Number(this.form.number),
          service_order_type_id: this.form.type.id ? this.form.type.id : this.form.type
        };
        await ServiceOrderService.updateServiceOrderDetails(this.serviceOrder.id, dataToSent);
        this.updateServiceOrderDetails(JSON.parse(JSON.stringify(this.form)));
        this.close();
      } catch (error) {
        this.isSnackbarActive = true;
      } finally {
        this.isLoading = false;
      }
    }
  },
  watch: {
    isActive() {
      if (this.isActive) {
        this.form = {
          number: this.serviceOrder.number,
          type: { ...this.serviceOrder.service_order_type }
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-container {
  padding: 20px;
  text-align: center;

  .button-container {
    width: 40%;
  }
}
</style>
